import { getDownloadList, getDataExportResult } from '@/api/global';
import { downloadFiles } from '@/utils/file-download';
import { Message } from 'element-ui';

const globalStore = {
  namespaced: true,
  state: {
    downloadText: '',
    downloadFlag: false,
    downloadParams: { page: 1, limit: 10 },
    downloadListData: {
      list: [],
      total: 0,
    },
    downloadPageTimer: {}, // 计时器数组
  },
  getters: {
    downloadText: (state) => state.downloadText,
    downloadFlag: (state) => state.downloadFlag,
    downloadListData: (state) => state.downloadListData,
    downloadParams: (state) => state.downloadParams,
  },
  actions: {
    // 获取下载列表
    async getDownloadList({ commit, state }) {
      try {
        const res = await getDownloadList({
          ...state.downloadParams,
          sysType: 'FIN_SERVICE', // 系统类型
        });
        const list = res.data || [];
        commit('SET_DOWNLOAD_LIST_DATA', { list, total: res.totalCount ?? 0 });
        commit('SET_DOWNLOAD_FLAG', false);
      } catch (error) {
        console.log(error);
        commit('SET_DOWNLOAD_LIST_DATA', { list: [], total: 0 });
        commit('SET_DOWNLOAD_TEXT', '');
        commit('SET_DOWNLOAD_FLAG', false);
      }
    },
    // 清除重置指定ID定时器
    resetIdInterval({ state }, id) {
      if (state.downloadPageTimer[id]) {
        window.clearInterval(state.downloadPageTimer[id]);
        state.downloadPageTimer[id] = null;
        delete state.downloadPageTimer[id];
      }
    },
    // 清除重置导出的定时器
    resetDownloadInterval({ state, dispatch }) {
      if (state.downloadPageTimer) {
        Object.keys(state.downloadPageTimer).forEach((key) => {
          if (state.downloadPageTimer[key]) {
            dispatch('resetIdInterval', state.downloadPageTimer[key]);
          }
        });
      }
    },
    // 设置定时器查询报表状态
    getFileDownload({ state, commit, dispatch }, { taskId, templateCode }) {
      dispatch('resetIdInterval', taskId);
      state.downloadPageTimer[taskId] = setInterval(async () => {
        try {
          const res = await getDataExportResult({ taskId }, templateCode);
          const { taskId: resReportId } = res.data || {};
          if (res?.data?.status === 'SUCCESS') {
            downloadFiles(res.data.fileUrl, res.data.fileName);
            dispatch('resetIdInterval', resReportId);
            dispatch('getDownloadList');
            commit('SET_DOWNLOAD_TEXT', '完成');
            Message({
              type: 'success',
              message: '导出成功！',
            });
          }
          if (res?.data?.status === 'FAIL') {
            dispatch('resetIdInterval', taskId);
            Message({
              type: 'error',
              message: '导出失败，请稍后再试',
            });
          }
        } catch (error) {
          dispatch('resetIdInterval', taskId);
        }
      }, 3000);
    },
  },
  mutations: {
    SET_DOWNLOAD_PARAMS: (state, params) => {
      state.downloadParams = {
        ...state.downloadParams,
        ...params,
      };
    },
    SET_DOWNLOAD_LIST_DATA: (state, { list, total }) => {
      state.downloadListData = {
        list,
        total,
      };
    },
    SET_DOWNLOAD_TEXT: (state, text) => {
      state.downloadText = text;
    },
    SET_DOWNLOAD_FLAG: (state, flag) => {
      state.downloadFlag = flag;
    },
  },
};

export default globalStore;
